export const PERSONAL = "personal finance management";     
export const RISK = "financial risk management";
export const ESTATE = "estate planning";
export const INSURANCE = "insurance fundamentals";
export const INVESTMENT = "investment basics";
export const PLAY = "play & learn";